import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { NotificationModalComponent } from '../../notification-modal.component';

/**
 * Prepaid wash-book card list of the order-request services form, shared by the
 * order-request and fleet-vehicle-found layouts.
 *
 * The redemption section renders the same cards read-only (`selectable` false: no
 * selling price, not focusable, clicks ignored); the purchase section renders them
 * selectable. Logic stays on {@link NotificationModalComponent}.
 */
@Component({
  selector: 'app-order-request-prepaid-cards',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './order-request-prepaid-cards.component.html',
  styleUrls: ['./order-request-prepaid-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class OrderRequestPrepaidCardsComponent {
  /** Owning modal — all state and handlers are read straight off it, as in the layouts. */
  @Input({ required: true }) host!: NotificationModalComponent;

  /** Show the catalog shimmer instead of the cards. */
  @Input() loading = false;

  /** Purchase section: cards are focusable, priced and clickable. */
  @Input() selectable = false;

  onSelect(bookId: string, event: Event): void {
    if (!this.selectable) {
      return;
    }
    this.host.selectOrderRequestPrepaid(bookId, event);
  }
}
